import ApperIcon from '@/components/ApperIcon';
export default function AuthLayout({ children, title, description, icon }) {
  return (
    <div className="min-h-svh flex flex-col items-center justify-center py-12 px-4">
      <div className="w-full max-w-[28rem]">
        <div className="flex flex-col items-center gap-3 mb-6">
          <div className="size-14 rounded-md bg-primary text-primary-foreground flex items-center justify-center font-heading text-2xl font-bold">
            P
          </div>
          <div className="text-center">
            <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
            {description && (
              <p className="text-sm text-muted-foreground mt-1">{description}</p>
            )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
